
import { Vue, Component, Prop } from "vue-property-decorator";
import vModal from "@/components/vModal.vue";
import { mapState } from "vuex";
import { LocalizationState } from "@/store/modules/LocalizationModule";

@Component({
  components: {
    vModal,
  },
  computed: {
    ...mapState({
      localizationState: (state: any) => state.LocalizationModule
    }),
  },
})
export default class vRecipeDeleteConfirmationModal extends Vue {
  @Prop() isRecipe!: boolean;
  @Prop() showWarningModal!: boolean;
  @Prop() isCancellation!: boolean;

  localizationState: LocalizationState;

  get translations() {
    return this.localizationState.translations;
  }

  closeWarningModal() {
    this.$emit("on-cancel");
    this.showWarningModal = false;
  }
}
